import Apollo from '@adoratorio/apollo';
import aion from './aion';

import utils from '@/scripts/utils';
// import BlobPointer from '@/scripts/BlobPointer';

// const apollo = {
//   ref: null,
//   blob: null,
//   init: () => {
//     apollo.blob = new BlobPointer(
//       document.querySelector('.pointer-wrapper'),
//       document.querySelector('.pointer-canvas'),
//     );
//     apollo.ref = new Apollo({
//       mode: Apollo.FOLLOW.MOUSE,
//       cursor: null,
//       type: Apollo.TYPE.CANVAS,
//       easing: {
//         mode: Apollo.EASING.OUT_CUBIC,
//         duration: utils.isTouchDevice() ? 800 : 1400,
//       },
//       targets: [],
//       detectTouch: true,
//       aion,
//       emitGlobal: true,
//     });
//     apollo.blob.load().then(() => apollo.blob.init(apollo.ref));
//   },
// }


const apollo = {
  ref: null,
  init: () => {
    apollo.ref = new Apollo({
      mode: Apollo.FOLLOW.CURSOR,
      cursor: document.querySelector('.pointer.apollo'),
      type: Apollo.TYPE.HTML,
      easing: {
        mode: Apollo.EASING.OUT_CUBIC,
        duration: 400,
      },
      targets: [],
      detectTouch: true,
      aion,
      emitGlobal: true,
      renderByPixel: true,
      // onEnter: this.hoverEnter,
      // onLeave: this.hoverLeave,
      // onUpdate: this.currentPosition,
    });
  },
}

export default apollo;